export default function PrivacyPage() {
  return (
    <main className="legal-page">
      <h1>UG SaaS Privacy Policy</h1>
      <p>Last updated: 8 September 2026</p>
      <h2>Information collected</h2>
      <p>
        Company, employee, store, production, machine, QR scan and delivery
        information required to operate the service.
      </p>
      <h2>Purpose</h2>
      <p>
        Data is used only for inventory control, elastic production
        traceability, warehouse movement, reporting, security and subscription
        administration.
      </p>
      <h2>Company separation</h2>
      <p>
        Every operational record is isolated using Company ID and Factory ID.
        Users can access only the company and factory assigned to their account.
      </p>
      <h2>Security and retention</h2>
      <p>
        Passwords are hashed. Authentication uses expiring access tokens.
        Administrative changes are audited. Company administrators can export
        backups and should retain them securely.
      </p>
      <h2>QR and camera</h2>
      <p>
        Camera access is used only when the user starts a QR scan. Images are
        processed for code recognition and are not intentionally stored.
      </p>
      <h2>Your responsibilities</h2>
      <p>
        Use HTTPS, protect login credentials, remove inactive users, review
        audit history and keep backup files private.
      </p>
      <h2>Contact</h2>
      <p>
        Contact your company administrator for access, correction or deletion
        requests.
      </p>
      <button onClick={() => window.history.back()}>Back</button>
    </main>
  );
}
